var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"workflow-fields__field"},[_c('q-checkbox',{attrs:{"value":_setup.workflowCheckboxFieldValue,"label":_vm.field.label},on:{"input":_setup.setField}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }